/**
 * Общий API-клиент аналитики продаж. Контракт — docs/SPEC_2026-10-20_ANALYTICS_WAVE2_SALES.md, раздел 3.3.
 * Гейтвей отдаёт { success, data }, поэтому ответ разворачиваем. Префикс `/api/v1` уже входит в baseURL
 * общего клиента, пути здесь начинаются с `/analytics`.
 */

import { api } from '../../../shared/api/client'
import { toApiParams } from './filterState'
import type { AnalyticsFilters, AnalyticsReference } from './types'

export const unwrap = (response: any) => response?.data?.data ?? response?.data

/** Убирает undefined/null/пустые значения из query: на сервер уходит только заданное. */
export function cleanParams(params: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue
    result[key] = value
  }
  return result
}

/** Query страницы: фильтры шапки + собственные параметры запроса. */
export function buildQuery(filters: AnalyticsFilters, extra: Record<string, unknown> = {}): Record<string, unknown> {
  return cleanParams({ ...toApiParams(filters), ...extra })
}

const asArray = <T>(value: unknown): T[] => (Array.isArray(value) ? (value as T[]) : [])

/** Справочники шапки: кабинеты, категории, производства, дизайнеры и границы данных. */
export async function getAnalyticsFilters(): Promise<AnalyticsReference> {
  const payload = unwrap(await api.get('/analytics/filters')) ?? {}
  return {
    sellers: asArray(payload.sellers),
    categories: asArray(payload.categories),
    productions: asArray(payload.productions),
    designers: asArray(payload.designers),
    period: {
      minDate: payload.period?.minDate ?? null,
      maxDate: payload.period?.maxDate ?? null,
    },
  }
}
